import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const GetCategoryData = createAsyncThunk(
  "categoryData/GetCategoryData",
  async (name, thunkAPI) => {
    try {
      const response = await axios.get(
        `${endPoint.GETCATEGORYDATA}?query=${name}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const GetCategoryDataSlice = createSlice({
  name: " ",
  initialState: {
    CategoryData: [],
    error: null,
  },
  reducers: {
    clearCategoryData: (state) => {
      state.CategoryData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetCategoryData.fulfilled, (state, action) => {
        state.CategoryData = action.payload;
      })
      .addCase(GetCategoryData.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearCategoryData } = GetCategoryDataSlice.actions;
export default GetCategoryDataSlice.reducer;
